import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet } from "auth/useApi2"
import Button from "components/Button"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect, useMemo } from "react"
import { Link, useHistory } from "react-router-dom"
import { StyledTableContainer } from "shared/styled/Global"
import { EditCustomerNavigation } from "../../components/EditCustomerNavigation"
import { useTranslation } from "react-i18next"

const EditCustomerCompanies = ({ match }) => {
  const routerHistory = useHistory()
  const { t } = useTranslation()
  const [customerResult, getCustomer] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)

  useEffect(() => {
    getCustomer(apiEndpoints.systemadmincustomers.getcustomerbyid.replace("{id}", match.params.id))
  }, [getCustomer, match.params.id])

  useEffect(() => {
    loadingContext.setLoading(() => customerResult.status === 1)
  })

  const columns = [
    {
      accessorKey: "name",
      header: t("global.name", "Name")
    },
    {
      accessorKey: "organisationNumber",
      header: t("global.org_no", "Org. no.")
    },
    {
      accessorKey: "streetAddress",
      header: t("global.postal_address", "Post address")
    },
    {
      accessorKey: "postalCode",
      header: t("global.postal_code", "Postal code")
    },
    {
      accessorKey: "cityAddress",
      header: t("global.city", "City")
    }
  ]

  return (
    <div>
      <EditCustomerNavigation customerId={match.params.id} />
      <Container>
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography mb={{ xs: 2, sm: 0 }} variant="h1">
              {t("settings.companies.administer_company", "Administer company")}
            </Typography>
            <Button
              color="primary"
              component={Link}
              to={allRoutes.SystemadminCustomersEditCompaniesAdd(match.params.id)}>
              {t("settings.form.button.add_company", "Add company")}
            </Button>
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          rows={customerResult.status === 2 && customerResult.data.companies}
          loadingState={customerResult.status}
          columns={columns}
          onRowClick={(row) =>
            routerHistory.push(
              allRoutes.SystemadminCustomersEditCompaniesEdit(row.original.customerId, row.original.id)
            )
          }
        />
      </StyledTableContainer>
    </div>
  )
}
export default EditCustomerCompanies
